/**
 * AppError
 *
 * From: 1.0.0
 * @packageDocumentation
 */

import { InvalidInfo } from '../../../../application/models/ErrorInfo';
import { Severity } from '../../../constants/Severity';
import { env } from '../../../utils/EnvUtils';

/**
 * エラークラスのベース
 */
export class AppError extends Error {
  severity: keyof typeof Severity;
  code?: string;
  status?: number;
  redirectTo?: string;
  description?: string;
  invalidInfos?: InvalidInfo[];
  key = env.APP_NAME;

  constructor(
    error?: Error,
    message?: string,
    redirectTo?: string,
    severity?: keyof typeof Severity,
    invalidInfos?: InvalidInfo[],
    key?: string,
    status?: number
  ) {
    super(message || error?.message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.redirectTo = redirectTo;
    this.severity = severity || 'WARNING';
    this.message = message || error?.message || 'アプリケーションエラーです';
    this.key = key || env.APP_NAME;
    this.invalidInfos = invalidInfos;
    this.status = status;

    if (error) {
      this.name = error.name;
      this.stack = error.stack;
    } else {
      this.name = 'AppError';
    }
  }

  get errorName(): string {
    return this.name;
  }
}
